// @ts-nocheck

// App
import { useDispatch } from 'react-redux';
import { useYieldCallback } from '@zillow/yield-callback';

// Actions
import AppActions from 'app/shared/flux/actions/AppActions';

// Icons
import IconHud from 'images/icons/hud.min.svg';

// Components
import FooterLinks from 'app/shared/modules/MobileSRP/Footer/FooterLinks';
import AppBadges from 'app/shared/modules/MobileSRP/Footer/AppBadges';

// Misc / utils
import PATHS_MANIFEST from 'app/shared/utils/pathsManifest';
import * as S from './styles';

const Footer = () => {
  // Redux
  const dispatch = useDispatch();

  const yieldTrackAndTransitionTo = useYieldCallback((page, path) => {
    window.router.transitionTo(path);
  });

  const yieldTrackAndOpenModal = useYieldCallback(() => {
    dispatch(AppActions.showPopupModal('PromptFeedback'));
  });

  const handleClick = (e, { path, isExternalUrl = false }) => {
    const page = e && e.currentTarget.getAttribute('data-footer-page');

    if (!isExternalUrl) {
      // Prevent the browser from going through with its default <a> behavior
      e.preventDefault();

      yieldTrackAndTransitionTo(page, path);
    }
  };

  const handleModal = (e) => {
    const page = e && e.currentTarget.getAttribute('data-footer-page');

    if (page === 'feedback') {
      yieldTrackAndOpenModal();
    }
  };

  return (
    <S.Footer>
      <FooterLinks onLinkClick={handleClick} onModalLinkClick={handleModal} />
      <S.AppBadgeSection>
        <AppBadges onBadgeClick={handleClick} />
      </S.AppBadgeSection>
      <S.Paragraph>
        Zillow Group is committed to ensuring digital accessibility for individuals with disabilities. We are
        continuously working to improve the accessibility of our web experience for everyone, and welcome feedback and
        accommodation requests. If you wish to report an issue or seek an accommodation please contact us at{' '}
        <S.Linker to="mailto:support@hotpads.com">support@hotpads.com</S.Linker>
      </S.Paragraph>
      <S.Paragraph>
        <S.Linker linkType="inherit" to={PATHS_MANIFEST.hud} target="_blank" rel="noopener">
          Fair Housing and Equal Opportunity
          <S.HudImg
            loading="lazy"
            src={IconHud}
            height="16px"
            width="16px"
            alt="United States Department of Housing and Urban Development badge"
          />
        </S.Linker>
      </S.Paragraph>
      <S.Paragraph>
        <S.Linker linkType="inherit" to={PATHS_MANIFEST.fairHousingGuide} target="_blank" rel="noopener">
          Fair Housing Guide
        </S.Linker>
      </S.Paragraph>
      <S.Paragraph>© {new Date().getFullYear()} HotPads</S.Paragraph>
    </S.Footer>
  );
};

export default Footer;
